const pixelId = process.env.REACT_APP_FPIXEL_ID;

const useFPixel = () => ({
  pixelId,
});

export default useFPixel;
